import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TuiTextfieldControllerModule, TuiTextareaModule, TuiInputModule, TuiSelectModule } from '@taiga-ui/legacy';
import {
  TuiDataListWrapper,
  TuiAccordion,
  TuiFieldErrorPipe,
  TuiFieldErrorContentPipe,
  TuiCheckbox,
  TuiBlock,
  TuiButtonLoading,
} from '@taiga-ui/kit';
import {
  TuiDataList,
  TuiError,
  TuiLoader,
  TuiScrollbar,
  TuiGroup,
  TuiLabel,
  TuiFlagPipe,
  TuiButton,
  TuiHint,
} from '@taiga-ui/core';
import { TuiAutoFocus, TuiLet } from '@taiga-ui/cdk';
import { NgxPermissionsModule } from 'ngx-permissions';
import { UserInfoModule } from '@src/app/modules/user-info';
import { ListModule } from '@src/app/shared/list';
import { SharedModule } from '@src/app/shared';
import { ComponentsModule } from '@src/app/components';
import { IconModule } from '@src/app/modules/icon';
import { HintModule } from '@src/app/modules/hint';
import { ThemeSwitcherModule } from '@src/app/modules/theme-switcher';
import { LanguageSwitcherModule } from '@src/app/modules/language-switcher';
import { NavigationModule } from '@src/app/modules/navigation';
import { DeleteAuthUserLinkModule } from '@src/app/modules/delete-auth-user-link';
import { FaqModule } from '@src/app/modules/faq';
import { AppConfigModule } from '@src/app/modules/app-config';
import { InputFilesModule } from '@src/app/modules/input-files';

import { SettingsComponent } from './settings.component';
import { SupportPageComponent, SendEmailFormComponent } from './support-page';
import { LicensesPageComponent } from './licenses-page/licenses-page.component';
import { ChangelogPageComponent } from './changelog-page/changelog-page.component';
import { PreferencesComponent } from './preferences';
import { ProfileComponent } from './profile';
import { NotificationsComponent } from './notifications/notifications.component';
import { LanguageComponent } from './language/language.component';
import { ThemeComponent } from './theme/theme.component';
import { DocumentsPageComponent } from './documents-page';

@NgModule({
  declarations: [
    SettingsComponent,
    NotificationsComponent,
    SupportPageComponent,
    SendEmailFormComponent,
    LicensesPageComponent,
    ChangelogPageComponent,
    PreferencesComponent,
    ProfileComponent,
    LanguageComponent,
    ThemeComponent,
    DocumentsPageComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    HintModule,
    IconModule,
    ListModule,
    NgxPermissionsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TuiAutoFocus,
    TuiButton,
    TuiBlock,
    TuiCheckbox,
    ...TuiDataList,
    ...TuiDataListWrapper,
    TuiGroup,
    TuiInputModule,
    TuiLoader,
    TuiSelectModule,
    TuiScrollbar,
    TuiTextareaModule,
    TuiTextfieldControllerModule,
    TuiFieldErrorPipe,
    TuiFieldErrorContentPipe,
    ...TuiHint,
    TuiError,
    ...TuiAccordion,
    TuiLabel,
    UserInfoModule,
    TuiFlagPipe,
    ThemeSwitcherModule,
    LanguageSwitcherModule,
    NavigationModule,
    TuiLet,
    DeleteAuthUserLinkModule,
    FaqModule,
    AppConfigModule,
    InputFilesModule,
    TuiButtonLoading,
  ],
  exports: [SettingsComponent],
})
export class SettingsModule {}
